export default "__VITE_ASSET__DbzRaxsK__"